import React, { useState, FormEvent, lazy, Suspense } from 'react';
import { ArrowRight } from 'lucide-react';

const OfferRequestForm = lazy(() => import('@/components/OfferRequestForm'));

const heroBg = '/images/hero-solyra-fotovoltaice.webp';

const content = {
  title: <>Află dacă un sistem fotovoltaic<br />chiar merită pentru casa ta.</>,
  subtitle: 'Analizăm locația, consumul și bugetul tău și îți spunem clar dacă are sens să investești — sau nu.',
  cta: 'Verifică gratuit pentru casa ta',
  trust: 'Analiză gratuită · Fără obligații ',
};

const Hero: React.FC = () => {
  const [address, setAddress] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (address.trim()) {
      setIsFormOpen(true);
    }
  };

  return (
    <section className="hero relative h-screen min-h-[600px] flex items-center">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroBg}
          alt="Casă modernă cu panouri fotovoltaice pe acoperiș"
          className="w-full h-full object-cover"
          style={{ objectPosition: '60% 35%' }}
          width="1920"
          height="1080"
          loading="eager"
          decoding="sync"
          {...({ fetchpriority: 'high' } as any)}
        />
        <div className="absolute inset-0 bg-foreground/65" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 lg:px-8">
        <div className="max-w-2xl">
          {/* Heading */}
          <h1 className="text-background text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-[1.1] mb-4">
            {content.title}
          </h1>

          {/* Subtitle */}
          <p className="text-background/80 text-lg sm:text-xl mb-8 max-w-lg">
            {content.subtitle}
          </p>

          {/* Address form */}
          <form onSubmit={handleSubmit} className="mb-4">
            <div className="relative flex items-center bg-background rounded-full overflow-hidden max-w-lg shadow-lg">
              <label htmlFor="hero-address" className="sr-only">Adresă</label>
              <input
                id="hero-address"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Introdu adresa ta"
                className="flex-1 px-6 py-4 text-base text-foreground placeholder:text-muted-foreground focus:outline-none bg-transparent"
                required
              />
              <button
                type="submit"
                className="flex-shrink-0 m-1.5 px-5 h-11 rounded-full bg-accent hover:bg-accent/90 transition-colors flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-accent text-accent-foreground text-sm font-semibold whitespace-nowrap"
              >
                <span className="hidden sm:inline">{content.cta}</span>
                <ArrowRight size={18} className="sm:hidden" />
              </button>
            </div>
          </form>

          {/* Trust line */}
          <p className="text-background/60 text-sm">{content.trust}</p>
        </div>
      </div>

      {isFormOpen && (
        <Suspense fallback={null}>
          <OfferRequestForm open={isFormOpen} onOpenChange={setIsFormOpen} defaultLocality={address} />
        </Suspense>
      )}
    </section>
  );
};

export default Hero;
